export = [
  { value: 'sum_pkts', column: 'f_sum_both_pkts', fn: 'sum', unit: 'packets' },
  { value: 'sum_in_pkts', column: 'f_sum_in_pkts', fn: 'sum', unit: 'in_packets' },
  { value: 'sum_out_pkts', column: 'f_sum_out_pkts', fn: 'sum', unit: 'out_packets' },

  // Out of Order In, Perc Out of Order In
  {
    value: 'sum_ooorder',
    column: 'f_sum_ooorder_in_pkts',
    columnVariations: ['f_frxtmtsb_ooorder_in_pkts', 'f_fsumlogb_ooorder_in_pkts'],
    fn: 'sum',
    unit: 'out_of_order_in'
  },
  {
    value: 'ooorder_to_pkts_ratio',
    fn: 'composite',
    leftOperand: 'sum_ooorder',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },
  {
    value: 'sum_ooorder_out',
    column: 'f_sum_ooorder_out_pkts',
    columnVariations: ['f_frxtmtsb_ooorder_out_pkts', 'f_fsumlogb_ooorder_out_pkts'],
    fn: 'sum',
    unit: 'out_of_order_out'
  },
  {
    value: 'ooorder_to_pkts_out_ratio',
    fn: 'composite',
    leftOperand: 'sum_ooorder_out',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },

  // Rxmits
  {
    value: 'sum_rxmits',
    column: 'f_sum_retransmitted_in_pkts',
    columnVariations: ['f_frxtmtsb_retransmitted_in_pkts', 'f_fsumlogb_retransmitted_in_pkts'],
    fn: 'sum',
    unit: 'retransmits_in'
  },
  {
    value: 'rxmits_to_pkts_ratio',
    fn: 'composite',
    leftOperand: 'sum_rxmits',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },
  {
    value: 'sum_rxmits_out',
    column: 'f_sum_retransmitted_out_pkts',
    columnVariations: ['f_frxtmtsb_retransmitted_out_pkts', 'f_fsumlogb_retransmitted_out_pkts'],
    fn: 'sum',
    unit: 'retransmits_out',
    unitMode: 'outsort'
  },
  {
    value: 'rxmits_to_pkts_out_ratio',
    fn: 'composite',
    leftOperand: 'sum_rxmits_out',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },
  {
    value: 'sum_rrxmits',
    column: 'f_sum_repeated_retransmits',
    columnVariations: ['f_frxtmtsb_repeated_retransmits', 'f_fsumlogb_repeated_retransmits'],
    fn: 'sum',
    unit: 'repeated_retransmits'
  },
  {
    value: 'rrxmits_to_pkts_ratio',
    fn: 'composite',
    leftOperand: 'sum_rrxmits',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },

  // Fragments
  {
    value: 'sum_fragments',
    column: 'f_sum_fragments',
    columnVariations: ['f_frxtmtsb_fragments', 'f_fsumlogb_fragments'],
    fn: 'sum',
    unit: 'fragments'
  },
  {
    value: 'fragments_to_pkts_ratio',
    fn: 'composite',
    leftOperand: 'sum_fragments',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },

  // Zero Windows
  {
    value: 'sum_zero_windows',
    column: 'f_sum_zero_windows',
    columnVariations: ['f_frxtmtsb_zero_windows', 'f_fsumlogb_zero_windows'],
    fn: 'sum',
    unit: 'zero_windows'
  },
  {
    value: 'zwins_to_pkts_ratio',
    fn: 'composite',
    leftOperand: 'sum_zero_windows',
    rightOperand: 'sum_pkts',
    compositeFn: 'divide'
  },

  // Receive Windows
  {
    value: 'sum_receive_window',
    column: 'f_sum_receive_window',
    columnPrefixes: ['f_percentile_sum(receive_window'],
    fn: 'sum',
    unit: 'receive_window'
  },

  // Latency
  {
    value: 'sum_client_latency_ms',
    column: 'f_sum_client_nw_latency_ms',
    columnPrefixes: ['f_percentile_sum(client_nw_latency_ms'],
    fn: 'sum',
    unit: 'client_latency'
  },
  {
    value: 'sum_server_latency_ms',
    column: 'f_sum_server_nw_latency_ms',
    columnPrefixes: ['f_percentile_sum(server_nw_latency_ms'],
    fn: 'sum',
    unit: 'server_latency'
  },
  {
    value: 'sum_appl_latency_ms',
    column: 'f_sum_appl_latency_ms',
    columnPrefixes: ['f_percentile_sum(appl_latency_ms'],
    fn: 'sum',
    unit: 'appl_latency'
  },
  {
    value: 'sum_fpex_latency_ms',
    column: 'f_sum_fpex_latency_ms',
    columnPrefixes: ['f_percentile_sum(fpex_latency_ms'],
    fn: 'sum',
    unit: 'fpex_latency'
  },
  { value: 'sum_flows', column: 'trautocount', columnPrefixes: ['f_fumlat', 'f_fsumloc'], fn: 'sum', unit: 'fps' }
];
